import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 6a3 3 0 013-3h15a3 3 0 013 3v4.969a1 1 0 01-2 0V6a1 1 0 00-1-1H4a1 1 0 00-1 1v11a1 1 0 001 1h9.4a1 1 0 110 2H4a3 3 0 01-3-3V6z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.816 15.026c-.986-.937-2.445-1.265-3.769-.847-1.323.418-2.285 1.51-2.484 2.821h-.037a.513.513 0 00-.526.5c0 .276.236.5.526.5h.037c.2 1.311 1.16 2.403 2.484 2.821 1.324.418 2.783.09 3.769-.847a.482.482 0 00-.028-.678.547.547 0 00-.714-.027 2.73 2.73 0 01-2.621.628c-.93-.265-1.629-.994-1.821-1.897h3.105c.29 0 .526-.224.526-.5s-.235-.5-.526-.5h-3.105c.192-.903.892-1.632 1.82-1.897a2.73 2.73 0 012.622.628c.128.142.33.204.523.16a.514.514 0 00.388-.369.485.485 0 00-.169-.496z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.816 19.974c-.986.937-2.445 1.265-3.769.847-1.323-.418-2.285-1.51-2.484-2.821h-.037a.514.514 0 01-.526-.5c0-.276.236-.5.526-.5h.037c.199-1.311 1.16-2.403 2.484-2.821 1.324-.418 2.783-.09 3.769.847.15.122.216.314.17.496a.514.514 0 01-.39.37.543.543 0 01-.522-.162 2.73 2.73 0 00-2.621-.627c-.824.235-1.467.835-1.737 1.597a2.397 2.397 0 00-.084.3h3.105c.29 0 .526.224.526.5s-.235.5-.526.5h-3.105c.021.102.05.202.084.3.27.762.913 1.362 1.737 1.597a2.73 2.73 0 002.62-.628.547.547 0 01.715.027c.195.184.207.48.028.678zM18.037 18.3c.256.62.8 1.11 1.498 1.309a2.43 2.43 0 002.332-.557l.008-.008.01-.007a.847.847 0 011.11.041.782.782 0 01.044 1.097l-.008.009-.008.008c-1.068 1.014-2.64 1.365-4.066.915-1.35-.426-2.36-1.508-2.649-2.836a.803.803 0 01-.608-.771c0-.379.265-.68.608-.771.288-1.329 1.299-2.41 2.649-2.836 1.422-.45 2.991-.1 4.058.908.23.194.336.5.261.795a.814.814 0 01-.613.588.844.844 0 01-.803-.243 2.43 2.43 0 00-2.325-.55c-.697.2-1.242.69-1.498 1.31h2.7c.442 0 .826.343.826.799s-.384.8-.826.8h-2.7z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { fill: "#292933", d: "M2 8h19v2H2z" })
);
export {
  l as default
};
